/**
 * @generated SignedSource<<fa1de1b0a78a86feef1ac60a5d98bb7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VisualBlockEditorPreviewQuery$variables = {
  emailTemplateId: string;
  htmlContent: string;
  language: string;
  textContent: string;
};
export type VisualBlockEditorPreviewQuery$data = {
  readonly emailTemplatePreview: {
    readonly htmlBody: string;
  } | null | undefined;
};
export type VisualBlockEditorPreviewQuery = {
  response: VisualBlockEditorPreviewQuery$data;
  variables: VisualBlockEditorPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emailTemplateId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "htmlContent"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "language"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "textContent"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "emailTemplateId",
        "variableName": "emailTemplateId"
      },
      {
        "kind": "Variable",
        "name": "htmlContent",
        "variableName": "htmlContent"
      },
      {
        "kind": "Variable",
        "name": "language",
        "variableName": "language"
      },
      {
        "kind": "Variable",
        "name": "textContent",
        "variableName": "textContent"
      }
    ],
    "concreteType": "EmailPreview",
    "kind": "LinkedField",
    "name": "emailTemplatePreview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "htmlBody",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VisualBlockEditorPreviewQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "VisualBlockEditorPreviewQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "dcafb9b577d59f592696f2ee291e0d91",
    "id": null,
    "metadata": {},
    "name": "VisualBlockEditorPreviewQuery",
    "operationKind": "query",
    "text": "query VisualBlockEditorPreviewQuery(\n  $emailTemplateId: ID!\n  $language: String!\n  $htmlContent: String!\n  $textContent: String!\n) {\n  emailTemplatePreview(emailTemplateId: $emailTemplateId, language: $language, htmlContent: $htmlContent, textContent: $textContent) {\n    htmlBody\n  }\n}\n"
  }
};
})();

(node as any).hash = "4bc652f5e7bcfacfb916018937877181";

export default node;
